import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchProfiles } from "./api";

const Profiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [page, setPage] = useState(0);
  const limit = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfiles = async () => {
      const data = await fetchProfiles(limit, page * limit);
      setProfiles(data.list || []);
    };
    loadProfiles();
  }, [page]);

  return (
    <div className="profiles-container">
      <div className="profiles-header">
        <h1>Customer Profiles</h1>
      </div>

      <div className="profiles-table-container">
        <table className="profiles-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {profiles.map((profile) => (
              <tr key={profile.itemId}>
                <td>{profile.itemId}</td>
                <td>{profile.properties?.firstname || "N/A"}</td>
                <td>{profile.properties?.lastname || "N/A"}</td>
                <td>{profile.properties?.email || "N/A"}</td>
                <td>
                  <button
                    onClick={() => navigate(`/cdp/profile/${profile.itemId}`)}
                    className="view-btn"
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button
          onClick={() => setPage(page - 1)}
          disabled={page === 0}
          className="pagination-btn"
        >
          Previous
        </button>
        <span className="page-info">Page {page + 1}</span>
        <button
          onClick={() => setPage(page + 1)}
          className="pagination-btn"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Profiles;
